import React from 'react';

import { Header, NavContainer } from 'ui/navigation/navbar';
import { Footer } from 'ui/navigation/footer';
import { PageContainer } from 'ui/layout/Containers';
import styled from 'styled-components';
import { HomepageNavigation } from 'pages/homepage/HomepageNavigation';
import { FloatingContactForm } from 'components/FloatingContactForm';


const MainContent = styled.main`
  flex: 1;
`;

export const LandingPage = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageContainer>
      <Header>
        <NavContainer>
          <HomepageNavigation />    
        </NavContainer>
      </Header>
      <MainContent>{children}</MainContent>
      <Footer>
        <p>&copy; 2026 SimpleWallet. All rights reserved.</p>
      </Footer>
      <FloatingContactForm />
    </PageContainer>
  );
}